<template>
  <!-- 低代码项目展示内容 -->
  <div class="lc-iframe-content">
    <!-- <nav-bar slot="header"></nav-bar> -->
    <div>
      <!-- <page-bar>
        <page-bar-item :label="label"></page-bar-item>
      </page-bar> -->
      <!-- <iframe
        v-if="lcDomain"
        ref="userIframe"
        :src="lcDomain + page"
        frameborder="0"
        name="rightFrame"
        id="rightFrame"
        width="100%"
        style="background: rgb(255, 255, 255); height: 94vh"
      ></iframe> -->
      <keep-alive>
        <div id="iframe-box"></div>
      </keep-alive>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
    };
  },
  // created() {
  //   this.page = this.$route.query.page
  // },
  activated() {
  },
  computed: {
    lcDomain() {
      return (
        this.$store.state.LC_DOMAIN || window.localStorage.getItem("LC_DOMAIN")
      );
    },
    page() {
      return this.$route.query.page;
    },
    label() {
      return this.$route.query.label;
    },
    computedCacheIframePageList() {
      return this.$store.state.cacheIframePageList
    }
  },
  watch: {
    "$route.query.page": {
      handler(newVal, oldVal) {
        if(newVal && this.$route.path == '/lc-iframe') {
          this.$nextTick(() => {
            if(!this.computedCacheIframePageList.includes(this.page)) { // 列表不存在则创建iframe
              let el = document.getElementById("iframe-box");
              let box = window.document.createElement("div");
              box.setAttribute('page', this.page)
              box.setAttribute('id', this.page.replaceAll('/', ''))
              let iframe = '<iframe ref="userIframe" frameborder="0" name="rightFrame" id="rightFrame" width="100%" style="background: rgb(255, 255, 255); height: 94vh" src="' + this.lcDomain + this.page + '"></iframe>';
              box.innerHTML = iframe
              el.appendChild(box);
              this.computedCacheIframePageList.push(this.page)
            }
            // 根据当前的page只显示对应的iframe页面, 其他页面隐藏
            console.log('this.computedCacheIframePageList:', this.computedCacheIframePageList)
            let iframeList = document.querySelectorAll('#iframe-box>div')
            iframeList.forEach(item => {
              console.log('iframe box =====>:', item)
              let pageStr = item.getAttribute('page')
              if(pageStr == this.page) {
                item.setAttribute('style', 'display: block')
              } else {
                item.setAttribute('style', 'display: none')
              }
            })
          })
        }
      },
      deep: true,
      immediate: true,
    },
  },
};
</script>

<style scoped>
.page-container-bg-solid .page-bar,
.page-content-white .page-bar {
  margin: 0;
}
</style>